export default {
  CANCELED: 'CANCELED',
  DELIVERED: 'DELIVERED',
  IN_ROUTING: 'IN_ROUTING',
  IN_TREATMENT: 'IN_TREATMENT',
  NOT_DELIVERED: 'NOT_DELIVERED',
  PROCESSING: 'PROCESSING',
  RETURNED: 'RETURNED'
};
